import {Row,Col,Card, Container} from "react-bootstrap"
import {Link} from "react-router-dom"
const Caviar = () =>{
    return <div style={{padding:"2%"}}>   
    <h1>Caviar</h1>
    <h3>Voltage controlled <a href="/CAV">CAV</a>.</h3>
    <ul className="flex-container">
    <li className = "flex-item" style={{width:"40rem", marginRight:"5rem"}}>


    <p>A multifunction module of 2 halves. One half can:</p>
      <ul>
          <li>Linear Crossfade</li>
          <li>4 quadrant multiply</li>
          <li>0-10V VCA</li>
          <li>Bipolar Voltage Source</li>
      </ul>
      <p>The halves are joined with some clever normalisation and a mixed output which unlocks all sorts of possibilities!</p>
    
      <h2>What does it have?</h2>
      <p>2 Active Linear Voltage Controlled Crossfader Units with independent and mixed outputs.</p>
      <p>DC coupled inputs</p>
      <p>Active output buffers with anti-drooping short protection with 1k output impedance</p>
      <p>45mm LED offset sliders with centre detent for tactile control and blinkenlights</p>

      <h2>How to Use It</h2>
      <p>A unit linearly crossfades between inputs A and B and expects a CV range between 5V (for 100% A), -5V (for 100% B). 
        Larger voltages will continue to amplify the relevant signal but is likely to start saturating or have non-linear gain. 
        The CV offset slider provides for the full +-5V range. 
      </p>
      <p>
        Input B is normalled to the inversion of A. when nothing is patched in the unit simply crossfades between A and -A which is a 4 quadrant multiplier!
        The slider includes a centre detent which should be around 0V with tuning - this lets you use it like a VCA with unipolar CV but please accept eliminating all noise is impossible
      </p>
      <p>
        If you patch something into B but leave it unconnected (or grounded) you create a cleaner linear VCA with unity gain at 10V.
      </p>
      <p>
        A of the first unit is normalled to a 5V reference. yielding a +- 5V CV source when nothing is patched in. 
        patched into only B get's you a weird attenuating offset which could be useful!
      </p>
      <p>
        A of the 2nd unit is normalled to A of the first for parallel processing. Self patch the output of the first into the 2nd for sequential processing.
      </p>

      <h3>Specs</h3>
      <p>Width: 6HP (30.48mm)</p>
      <p>height: 3U (128.5mm)</p>
      <p>depth: ~40mm (stack of 2 PCBs with stackable header which can be trimmed) </p>
      <p>+12V: ~50mA  (TBC) </p>
      <p>-12V: ~50mA TBC (TBC) </p>


    <h3>DIY</h3>
    <p>If you have a diy kit then check out <a href="/CAVIAR/Build">the DIY guide</a></p>
    </li>
    <li className = "flex-item" style={{width:"15rem"}}>
      <img src="./CAVIAR.jpg" style={{width:"100%"}}></img>
    </li>
    </ul>
    </div>

}

export default Caviar